'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../tslib.es6-CZ43up4V.js');
const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_pr4ue_1";
const titleLabelWrapper = "_title-label-wrapper_pr4ue_67";
const title = "_title_pr4ue_67";
const label = "_label_pr4ue_98";
const removalButton = "_removalButton_pr4ue_116";
const styles = {
	root: root,
	titleLabelWrapper: titleLabelWrapper,
	title: title,
	label: label,
	removalButton: removalButton
};

const FilterChip = (_a) => {
  var _b, _c, _d;
  var { children, className, id, isDisabled, label, showsCheckmarkWhenSelected = false, size: sizeFromProps = "small", style, title, variant: variantFromProps = "primary" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "id", "isDisabled", "label", "showsCheckmarkWhenSelected", "size", "style", "title", "variant"]);
  const tagGroupContext = React.useContext(reactAriaComponents.TagGroupContext);
  const size = (_b = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.size) !== null && _b !== void 0 ? _b : sizeFromProps;
  const variant = (_c = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.variant) !== null && _c !== void 0 ? _c : variantFromProps;
  return React__default.default.createElement(reactAriaComponents.Tag, Object.assign({}, props, { className: clsx.clsx(className, styles.root), "data-selectable": (_d = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.selectionMode) !== null && _d !== void 0 ? _d : void 0, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled, style, textValue: label ? `${title} ${label}` : title }), (tagRenderProps) => React__default.default.createElement(
    React__default.default.Fragment,
    null,
    tagRenderProps.isSelected && showsCheckmarkWhenSelected && React__default.default.createElement(designSystem.Icon, { name: "formCheck" }),
    typeof children === "function" ? children(tagRenderProps) : children,
    title && React__default.default.createElement(
      "div",
      { className: styles.titleLabelWrapper, "data-zds": true },
      React__default.default.createElement("span", { className: styles.title, "data-zds": true, "data-testid": "filter-chip-title" }, title),
      !!label && React__default.default.createElement("span", { className: styles.label, "data-zds": true, "data-testid": "filter-chip-label" }, label)
    ),
    tagRenderProps.allowsRemoving && React__default.default.createElement(
      reactAriaComponents.Button,
      { className: styles.removalButton, "data-zds": true, slot: "remove" },
      React__default.default.createElement(designSystem.Icon, { color: "StrokeStronger", name: "formX" })
    )
  ));
};
const FilterChipIcon = ({ name }) => React__default.default.createElement(designSystem.Icon, { name });

exports.FilterChip = FilterChip;
exports.FilterChipIcon = FilterChipIcon;
//# sourceMappingURL=FilterChip.cjs.js.map
